import {Tr, TrSpace} from "@/i18n/i18n";
import {injectable} from 'inversify';
import Scene = Phaser.Scene;
import {HealthTimerPanel} from "@/scenes.ui/health-timer-panel";
import {HealthRestorePanel} from "@/scenes.ui/health-restore-panel";
import {BasePanel} from "@/scenes.ui/base-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import PlayerStore from "@/store/player";
import SoundUtils from "@/utils/sound-utils";
import {InterfaceMode, PayType, RestoreOptions} from "@/store/player/types";
import BaseSound = Phaser.Sound.BaseSound;
import RewardedUtils from "@/utils/rewarded-utils";
import {RewardedAdvType} from "@/store/shop/types";
import CU from "@/utils/c-u";

@injectable()
export class HealthService {

    private readonly EXP_PANEL_OFFSET_POSITION: number = 37;

    private scene: Scene | undefined;
    private canvas: HTMLCanvasElement | undefined;
    private healthTimerId: number | undefined;
    private healthTimer: HealthTimerPanel | undefined = undefined;
    private shopCallback!: () => unknown;
    private onChangeCallback!: (y: number) => unknown;

    private clickSound!: BaseSound | undefined;
    private levelUpSound!: BaseSound | undefined;
    private awardSound!: BaseSound | undefined;

    public initHealthTimer(scene: Scene, canvas: HTMLCanvasElement, shopCallback: () => unknown,
                    clickSound: BaseSound | undefined, levelUpSound: BaseSound | undefined,
                           awardSound: BaseSound | undefined, onChangeCallback: (y: number) => unknown,
                           interfaceMode: InterfaceMode | undefined = undefined): void {
        this.scene = scene;
        this.canvas = canvas;
        this.shopCallback = shopCallback;
        this.onChangeCallback = onChangeCallback;

        this.clickSound = clickSound;
        this.levelUpSound = levelUpSound;
        this.awardSound = awardSound;

        this.refreshHealthTimer(interfaceMode);
    }

    private refreshHealthTimer(interfaceMode: InterfaceMode | undefined) {

        let player = PlayerStore.getPlayer();
        if (this.healthTimerId) {
            clearInterval(this.healthTimerId);
            this.healthTimerId = undefined;
        }
        if (this.healthTimer) {
            this.healthTimer.setVisible(false);
            this.healthTimer.destroy();
            this.healthTimer = undefined;
        }
        if (player.healthRecoverAt && player.healthRecoverAt > 0) {
            let shift = interfaceMode === InterfaceMode.MODERN ? -86 : -45;
            this.healthTimer = new HealthTimerPanel(this.scene!, 0, this.canvas!.height + shift * CU.S, player, () => {
                PlayerStore.fetchRestoreHealthOptions().then((options: RestoreOptions) => {
                    let func = () => {
                        BasePanel.closeAll();
                        if (this.healthTimerId) {
                            clearInterval(this.healthTimerId);
                        }
                        if (this.healthTimer) {
                            this.healthTimer.setVisible(false);

                            if (this.onChangeCallback != null) {
                                this.onChangeCallback(-37);
                            }

                            this.healthTimer.destroy();
                        }
                        new FeedbackPanel(self.scene!, Tr('zdorove.vosstanovleno'), undefined, true).show();
                    };
                    let restorePanel = new HealthRestorePanel(this.scene!, this.canvas!, options, () => {

                        if (options.price <= PlayerStore.getPlayer().mithril) {
                            SoundUtils.play(this.awardSound);
                            PlayerStore.restoreHealth(PayType.GEMS).then(() => {
                                func();
                            });
                        } else {
                            SoundUtils.play(this.levelUpSound);
                            this.shopCallback!();
                        }
                    }, () => {
                        if (options.rewardedWatchesToday < options.rewardedWatchesMax) {
                            RewardedUtils.watchRewarded(this.scene!, RewardedAdvType.HEALTH_RESTORE, () => {
                                PlayerStore.restoreHealth(PayType.ADV).then(() => {
                                    func();
                                });
                            });
                        } else {
                            new FeedbackPanel(this.scene!, TrSpace('2.mr') + String(options.rewardedWatchesMax) + Tr('t.p.d'), undefined, true).show();
                        }
                    });
                    SoundUtils.play(this.clickSound);
                    restorePanel.open();
                });
            }, interfaceMode);
            this.scene!.add.existing(this.healthTimer);

            if (this.onChangeCallback != null) {
                this.onChangeCallback(this.EXP_PANEL_OFFSET_POSITION);
            }

            let self = this;
            this.healthTimerId = setInterval(() => {
                if (this.healthTimer && this.healthTimer.active && this.scene!.scene.isActive()) {
                    let completed: boolean = this.healthTimer!.refreshTimer();
                    if (completed) {
                        clearInterval(self.healthTimerId);
                        PlayerStore.fetchPlayerSilent().then(() => {
                            if (this.onChangeCallback != null) {
                                this.onChangeCallback(-this.EXP_PANEL_OFFSET_POSITION);
                            }
                            self.refreshHealthTimer(interfaceMode);
                        });
                    }
                }
            }, 1000);
        }
    }
}
